import { SubsectionTitle, Subtitle } from '@if/mui'
import { Accordion, AccordionDetails, AccordionSummary, Card, CardHeader } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ENTRIES = ['eligibility', 'cost', 'timing', 'cancellation'] as const
type FaqKey = (typeof ENTRIES)[number]

export const ProtectionPlanFaq = () => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState<FaqKey | false>(ENTRIES[0])
  return (
    <Card>
      <CardHeader disableTypography title={<SubsectionTitle>{t('protectionPlan.faq.title')}</SubsectionTitle>} />
      {ENTRIES.map((key) => (
        <Accordion
          key={key}
          disableGutters
          expanded={expanded === key}
          onChange={(_, isExpanded) => setExpanded(isExpanded ? key : false)}
        >
          <AccordionSummary sx={{ '&&.Mui-focusVisible': { outline: 'none', bgcolor: 'transparent' } }}>
            {t(`protectionPlan.faq.${key}.question`)}
          </AccordionSummary>
          <AccordionDetails>
            <Subtitle>{t(`protectionPlan.faq.${key}.answer`)}</Subtitle>
          </AccordionDetails>
        </Accordion>
      ))}
    </Card>
  )
}
